
import {defineComponent} from "vue";
import store from "@/store/blog";

export default defineComponent({
  name: "BlogNav",
  methods: {
    setIx(i: number){
      store.dispatch('setBlogIx', i)
    },
    ixToLink(ix: number) : string{
      return "/blog/" + ("00" + ix).slice(-3) + "/"
    },
    ixIsCurrent(ix:number) : boolean{
      return ix === this.currentPageIx;
    }
  },
  computed: {
    blogTitles() : Array<string> {
      return store.state.blogTitles;
    },
    currentPageIx(): number {
      return <number> this.$route.meta.ix;
    }
  },
});
